import { datesToISO, swal } from "@";
import type { AddVerificationFilesRequest, VerifySearchValues } from "@/features/operations/verifications/verify/types.ts";

// ============================================
// Confirmation Dialogs
// ============================================

// Show confirmation dialog before unassigning orders
export const unassignOrdersConfirmDialog = async (): Promise<boolean> => {
  const { isConfirmed } = await swal(
    "",
    "إلغاء اسناد الطلبات المحددة من التوثيق",
    "نعم إلغاء الإسناد",
  );
  return isConfirmed;
};

// Show confirmation dialog before returning accepted verification to driver
export const returnAcceptedVerificationConfirmDialog =
  async (): Promise<boolean> => {
    const { isConfirmed } = await swal(
      "",
      "إلغاء توثيق الطلبات المحددة",
      "نعم إلغاء التوثيق",
    );
    return isConfirmed;
  };

// Show confirmation dialog before marking verification stages as printed
export const markAsPrintedConfirmDialog = async (): Promise<boolean> => {
  const { isConfirmed } = await swal(
    "تأكيد الطباعة",
    "هل تمت الطباعة بنجاح؟",
    "نعم ",
  );
  return isConfirmed;
};

// search handler
export const searchHandler = (search: VerifySearchValues) => {
  return {
    searchKey: search.searchKey,
    stageName: search.stageName,
    driverId: search.driverId || null,
    toTime: datesToISO(search.toTime),
    fromTime: datesToISO(search.fromTime),
    projectIds: search.projectIds,
    projectAttributeId: parseInt(search.projectAttributeId) || null,
    verificationStageStatus: parseInt(search.verificationStageStatus) || null,
    smsSendingDateTimeFrom: datesToISO(search.smsSendingDateTimeFrom),
    smsSendingDateTimeTo: datesToISO(search.smsSendingDateTimeTo),
    projectClassificationId: parseInt(search.projectClassificationId) || null,
    isPrinted: search.isPrinted === "" ? null : search.isPrinted === "true",
    isFirstStageVerified:
      search.isFirstStageVerified === ""
        ? null
        : search.isFirstStageVerified === "true",
  };
};

export const acceptOrdersConfirmDialog = async (): Promise<boolean> => {
  const { isConfirmed } = await swal("", "تاكيد الطلبات المحددة", "نعم تاكيد");
  return isConfirmed;
};



// ============================================
// files upload helpers
// ============================================

// IDs list or bulk upload search values
export const appendIdsListOrBulkUploadSearchValues = ({
  data,
  form,
}: {
  data: AddVerificationFilesRequest;
  form: FormData;
}) => {
  if (data.selectingAll) {
    const searchValues = searchHandler(data.searchValues);
    const prefix = "SearchVerificationsRequestViewModel";

    Object.entries(searchValues).forEach(([key, value]) => {
      // const serverKey = fieldMap[key];
      if (!key) return;
      if (value === null || value === undefined || value === "") return;
      const fullKey = `${prefix}.${key}`;
      if (Array.isArray(value)) {
        value.forEach((v) => form.append(fullKey, String(v)));
      } else {
        form.append(fullKey, String(value));
      }
    });
  } else {
    data.verificationStagesIds.forEach((id) =>
      form.append("VerificationStagesIds", String(id)),
    );
  }
};

// append photos to form
export const appendPhotosToForm = ({
  data,
  form,
}: {
  data: AddVerificationFilesRequest;
  form: FormData;
}) => {
  data?.photos && data?.photos?.length > 0
      ? data.photos?.forEach((file) => form.append("Photos", file))
      : null;
};

// append videos to form
export const appendVideosToForm = ({
  data,
  form,
}: {
  data: AddVerificationFilesRequest;
  form: FormData;
}) => {
  data?.videos && data?.videos?.length > 0
      ? data.videos?.forEach((file) => form.append("Videos", file))
      : null;
};